import React from 'react';
import { string, object, bool } from 'prop-types';

import Error from 'common/Error/Error';
import PasswordStrengthMeter from 'common/Error/PasswordStrengthMeter';

const ValidationsNoteDisplayer = ({ note, styles, wasBlured, error, darkBg }) => {
  const renderNote = note ? <p key={'helperNote'} className={`small ${styles.helperNote}`}>{note}</p> : null;

  const renderError = error.className ?
    <PasswordStrengthMeter {...error} key={'validationError'} finishedTyping={wasBlured} /> :
    wasBlured && error.error && <Error key={'validationError'} {...error} darkBg={darkBg} />;

  return <div className={styles.validationNotesWrapper}>{[renderError, renderNote]}</div>;
};

ValidationsNoteDisplayer.propTypes = {
  note: string,
  styles: object,
  isFocused: bool,
  wasBlured: bool,
  hasValue: bool,
  error: object,
  darkBg: bool,
};

ValidationsNoteDisplayer.displayName = 'ValidationsNoteDisplayer';

export default ValidationsNoteDisplayer;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/ValidationsNoteDisplayer.js